import { render, staticRenderFns } from "./HandicapRRStatistics.vue?vue&type=template&id=04eeb652&scoped=true"
import script from "./HandicapRRStatistics.vue?vue&type=script&lang=js"
export * from "./HandicapRRStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eeb652",
  null
  
)

export default component.exports